import styled from 'styled-components';
import React from 'react';
import {
	CSSMediaSize,
	SOCIAL,
	EMAIL,
} from '../../const';
import { CopyButton } from '../../components/copy-button';
import { ROUTES } from '../../routes';
import {
	Guide,
	NGuide,
} from '../../components/guide';
import { JALeaderboard } from '../../components/juicyads/leaderbaord';

const guidePath: NGuide.IGuidePathItem[] = [
	{
		name: 'Home',
		route: ROUTES.home,
	},
	{
		name: 'Contact',
		route: ROUTES.contact,
	},
];

const Contact = () => {
	return (
		<ContactStyle>
			<JALeaderboard
				id={1097820}
				idMobile={1097821}
			/>
			<Guide path={guidePath} />
			<h2>
				Contact information we are willing to
				disclose
			</h2>
			<div className="social-row">
				Email:{' '}
				<a
					className="hover-colored"
					href={`mailto:${EMAIL}`}
				>
					{EMAIL}
				</a>
				<CopyButton data={EMAIL} />
				<div className="description">
					<span>
						Inquiries, direct contact,
						suggestions, support and so on...
						(everything and anything)
					</span>
				</div>
			</div>
			{SOCIAL.map((social) => (
				<div
					key={social.name}
					className="social-row"
				>
					{social.name}:{' '}
					<a
						className="hover-colored"
						target="_blank"
						href={social.link}
						rel="noreferrer"
					>
						{social.socialName
							? social.socialName
							: social.link}
					</a>
					<CopyButton data={social.link} />
					{social.description ? (
						<div className="description">
							<span>{social.description}</span>
						</div>
					) : null}
				</div>
			))}
			<p className="gray smol">
				Of course you can find us on other places,
				that is if you know where to look ;P
			</p>
			<JALeaderboard
				id={1097822}
				idMobile={1097823}
			/>
		</ContactStyle>
	);
};

export default Contact;

const ContactStyle = styled.div`
	flex-shrink: 0;
	flex-grow: 1;
	padding: 20px 50px;
	> h2 {
		margin-bottom: 20px;
	}
	.social-row {
		margin: 5px 0;
		> .description {
			margin: 0;
			font-size: 14px;
			color: ${({ theme }) =>
				theme?.palette?.text?.secondary};
			border-left: 1px solid
				${({ theme }) =>
					theme?.palette?.text?.secondary};
			padding-left: 10px;
		}
	}
	.gray {
		color: ${({ theme }) =>
			theme?.palette?.text?.secondary};
	}
	.smol {
		font-size: 12px;
		color: ${({ theme }) =>
			theme?.palette?.text?.secondary};
	}
	.copy-button {
		padding-left: 10px;
	}

	${CSSMediaSize.phone} {
		padding: 20px 10px;
	}
`;
